import getHostname from './getHostname';

export default function shouldNoFollow(href: string): boolean {
  const hostname = getHostname(href);
  return !hostname.match(/(^|\.)canny.io$/gi);
}
